import BgChanger from '@/public/images/landing/professionalEditing/bgChanger.webp';
import BgRemover from '@/public/images/landing/professionalEditing/bgRemover.webp';
import Captions from '@/public/images/landing/professionalEditing/captions.webp';
import Collages from '@/public/images/landing/professionalEditing/collages.webp';
import Eraser from '@/public/images/landing/professionalEditing/eraser.webp';
import Fonts from '@/public/images/landing/professionalEditing/fonts.webp';
import Enhancer from '@/public/images/landing/professionalEditing/imgEnhancer.webp';
import ImgGen from '@/public/images/landing/professionalEditing/imgGen.webp';
import Reel from '@/public/images/landing/professionalEditing/reels.webp';
import SmmAssist from '@/public/images/landing/professionalEditing/smmAssist.webp';
import Templates from '@/public/images/landing/professionalEditing/templates.webp';
import VideoEditor from '@/public/images/landing/professionalEditing/videoEditor.webp';

export const editingData = [
	{
		text: 'templates',
		image: Templates,
		size: 'wide',
	},
	{
		text: 'reels',
		image: Reel,
		size: 'wide',
	},
	{
		text: 'remover',
		image: BgRemover,
	},
	{
		text: 'changer',
		image: BgChanger,
	},
	{
		text: 'enhancer',
		image: Enhancer,
	},
	{
		text: 'captions',
		image: Captions,
		size: 'wide',
	},
	{
		text: 'imgGen',
		image: ImgGen,
		size: 'wide',
	},
	{
		text: 'smmAssist',
		image: SmmAssist,
	},
	{
		text: 'eraser',
		image: Eraser,
	},
	{
		text: 'videoEditor',
		image: VideoEditor,
	},
	{
		text: 'collages',
		image: Collages,
		size: 'wide',
	},
	{
		text: 'fonts',
		image: Fonts,
		size: 'wide',
	},
];
